import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "PERSOFORMATCODE";
export const persoFormatCodeConstants = createCRUDConstants(nameSpace);
